import { Fragment, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import React from "react";
import RouteList from "./routes/RouteList";
import { history } from "_utils";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { alertActions, authActions } from "_store";
import { authChannel } from "_utils/authChannel";
import {
  markActivity,
  broadcastActivity,
  getLastActivity,
  IDLE_TIMEOUT_MS,
  shouldAcquireLogoutLock,
  releaseLogoutLock,
} from "_utils/idleTracker";
import { LOGOUT_MSG, SESSION_EXPIRED } from "constants/labels";

const App = () => {
  const dispatch = useDispatch();
  const hasBootstrapped = useRef(false);
  const { isInitialized, isAuthenticated } = useSelector((state) => state.auth);

  history.navigate = useNavigate();
  history.location = useLocation();

  useEffect(() => {
    if (!hasBootstrapped.current) {
      hasBootstrapped.current = true;
      dispatch(authActions.getUserDetailsAndAccess());
    }
  }, [dispatch]);

  useEffect(() => {
    authChannel.onmessage = (event) => {
      const { type: eventDataType } = event.data;
      if (eventDataType === "LOGOUT" || eventDataType === "SESSION_EXPIRED") {
        dispatch(alertActions.clear());
        let message = LOGOUT_MSG;
        let header = "Log Out";

        if (eventDataType === "SESSION_EXPIRED") {
          message = SESSION_EXPIRED;
          header = "Session Timeout";
        }
        dispatch(authActions.clear());
        dispatch(
          alertActions.success({
            message,
            header,
            showAfterRedirect: true,
          }),
        );
      }
    };

    return () => {
      authChannel.onmessage = null;
    };
  }, [dispatch]);

  useEffect(() => {
    if (!isAuthenticated) return;

    const onActivity = () => {
      markActivity();
      broadcastActivity();
    };
    const events = ["mousemove", "keydown", "click", "scroll", "focus"];
    events.forEach((e) => window.addEventListener(e, onActivity));

    return () => {
      events.forEach((e) => window.removeEventListener(e, onActivity));
    };
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) return;

    const attemptIdleLogout = () => {
      const lastActivity = getLastActivity();
      const idleFor = Date.now() - lastActivity;

      if (idleFor < IDLE_TIMEOUT_MS) return;
      if (document.visibilityState !== "visible") return;
      if (!shouldAcquireLogoutLock()) return;

      authChannel.postMessage({ type: "SESSION_EXPIRED" });
      dispatch(authActions.logout(true)).finally(() => {
        releaseLogoutLock();
      });
    };

    attemptIdleLogout();
    
    const interval = setInterval(() => {
      attemptIdleLogout();
    }, 60 * 1000);

    const handleVisibility = () => {
      if (document.visibilityState === "visible" && isAuthenticated) {
        attemptIdleLogout();
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [isAuthenticated, dispatch]);

  if (!isInitialized) return <div />;

  return (
    <div>
      <Fragment>
        <RouteList />
      </Fragment>
    </div>
  );
};

export default App;
